import { h } from "harmaja"
import * as L from "lonna"
import { canMove } from "../board-permissions"
import { bringToFront, sendToBack } from "../item-z-order"
import { SubmenuProps } from "./ContextMenuView"
import { BoardFocus } from "../board-focus"

// ponytail: inline icons, swap for proper ones in Icons.tsx when the UI gets designed
const FrontIcon = () => (
    <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="2">
        <rect x="3" y="9" width="12" height="12" stroke-opacity="0.4" />
        <rect x="9" y="3" width="12" height="12" fill="currentColor" />
    </svg>
)
const BackIcon = () => (
    <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="2">
        <rect x="9" y="3" width="12" height="12" stroke-opacity="0.4" />
        <rect x="3" y="9" width="12" height="12" fill="currentColor" />
    </svg>
)

export function zOrderMenu({ board, focusedItems, dispatch }: SubmenuProps) {
    const movable = L.view(focusedItems, (f) => f.items.filter(canMove))
    const focusOf = (): BoardFocus => ({
        status: "selected",
        itemIds: new Set(movable.get().map((i) => i.id)),
        connectionIds: new Set(),
    })
    return L.view(movable, (items) =>
        items.length === 0
            ? []
            : [
                  <div className="icon-group z-order">
                      <span
                          className="icon"
                          title="Bring to front (])"
                          onClick={() => bringToFront(board.get(), focusOf(), dispatch)}
                      >
                          <FrontIcon />
                      </span>
                      <span
                          className="icon"
                          title="Send to back ([)"
                          onClick={() => sendToBack(board.get(), focusOf(), dispatch)}
                      >
                          <BackIcon />
                      </span>
                  </div>,
              ],
    )
}
